import { render, staticRenderFns } from "./ButtonFoto.vue?vue&type=template&id=2eeaf588&scoped=true&"
import script from "./ButtonFoto.vue?vue&type=script&lang=js&"
export * from "./ButtonFoto.vue?vue&type=script&lang=js&"
import style0 from "./ButtonFoto.vue?vue&type=style&index=0&id=2eeaf588&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eeaf588",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContent } from 'vuetify/lib/components/VContent';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VContent,VIcon,VLayout})
